var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedkitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188.079,
    height: 190.881,
    viewBox: "0 0 188.079 190.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5068",
    "data-name": "Rectangle 5068",
    width: 188.079,
    height: 190.881,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9368",
    "data-name": "Group 9368",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9367",
    "data-name": "Group 9367",
    transform: "translate(0 0.002)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27368",
    "data-name": "Path 27368",
    d: "M885.924,125.437a2.186,2.186,0,0,1-2.186-2.185V102.384h-14.5a2.186,2.186,0,1,1,0-4.371h16.683a2.186,2.186,0,0,1,2.186,2.186v23.052a2.186,2.186,0,0,1-2.186,2.185m-74.671,0a2.186,2.186,0,0,1-2.186-2.185V100.2a2.187,2.187,0,0,1,2.186-2.186h16.684a2.186,2.186,0,0,1,0,4.371h-14.5v20.867a2.186,2.186,0,0,1-2.186,2.185",
    transform: "translate(-754.548 -91.409)",
    fill: "#ff455c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27369",
    "data-name": "Path 27369",
    d: "M2250.538,444.422h-21.012a2.186,2.186,0,0,1-2.186-2.186V426.887a2.186,2.186,0,0,1,2.186-2.185h21.012a2.186,2.186,0,0,1,2.186,2.185v15.349a2.186,2.186,0,0,1-2.186,2.186",
    transform: "translate(-2077.251 -396.084)",
    fill: "#a8b3ba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27370",
    "data-name": "Path 27370",
    d: "M210.3,444.422H189.293a2.186,2.186,0,0,1-2.186-2.186V426.887a2.186,2.186,0,0,1,2.186-2.185H210.3a2.186,2.186,0,0,1,2.186,2.185v15.349a2.186,2.186,0,0,1-2.186,2.186",
    transform: "translate(-174.499 -396.084)",
    fill: "#a8b3ba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27371",
    "data-name": "Path 27371",
    d: "M691.052,458.794H670.4a2.186,2.186,0,0,1-2.185-2.186V442.3a2.186,2.186,0,0,1,2.185-2.186h20.653a2.186,2.186,0,0,1,2.185,2.186v14.309a2.186,2.186,0,0,1-2.185,2.186",
    transform: "translate(-623.187 -410.455)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27372",
    "data-name": "Path 27372",
    d: "M1774.43,458.794h-20.651a2.186,2.186,0,0,1-2.186-2.186V442.3a2.186,2.186,0,0,1,2.186-2.186h20.651a2.186,2.186,0,0,1,2.186,2.186v14.309a2.186,2.186,0,0,1-2.186,2.186",
    transform: "translate(-1633.562 -410.455)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27373",
    "data-name": "Path 27373",
    d: "M209.221,2577.512H179.714a2.186,2.186,0,0,1-2.186-2.186v-14.068a2.186,2.186,0,0,1,2.186-2.186h29.507a2.186,2.186,0,0,1,2.186,2.186v14.068a2.186,2.186,0,0,1-2.186,2.186",
    transform: "translate(-165.565 -2386.631)",
    fill: "#454545",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27374",
    "data-name": "Path 27374",
    d: "M2142.527,2577.512h-29.508a2.187,2.187,0,0,1-2.186-2.186v-14.068a2.187,2.187,0,0,1,2.186-2.186h29.508a2.186,2.186,0,0,1,2.186,2.186v14.068a2.186,2.186,0,0,1-2.186,2.186",
    transform: "translate(-1968.596 -2386.631)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27375",
    "data-name": "Path 27375",
    d: "M185.895,785.313H2.186A2.186,2.186,0,0,1,0,783.127V654.652a2.186,2.186,0,0,1,2.186-2.185H185.893a2.186,2.186,0,0,1,2.186,2.185V783.127a2.185,2.185,0,0,1-2.185,2.186",
    transform: "translate(0 -608.501)",
    fill: "#e62e2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27376",
    "data-name": "Path 27376",
    d: "M259.048,652.467h22.893v91.21a2.186,2.186,0,0,1-2.186,2.186H261.234a2.186,2.186,0,0,1-2.186-2.186Z",
    transform: "translate(-241.592 -608.501)",
    fill: "#eef6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27377",
    "data-name": "Path 27377",
    d: "M281.941,2337.315H259.048v-18.523a2.186,2.186,0,0,1,2.186-2.186h18.521a2.186,2.186,0,0,1,2.186,2.186Z",
    transform: "translate(-241.592 -2160.503)",
    fill: "#eef6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27378",
    "data-name": "Path 27378",
    d: "M2192.377,652.467h22.892v91.21a2.186,2.186,0,0,1-2.186,2.186h-18.521a2.185,2.185,0,0,1-2.185-2.186Z",
    transform: "translate(-2044.645 -608.501)",
    fill: "#eef6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27379",
    "data-name": "Path 27379",
    d: "M2215.268,2337.315h-22.892v-18.523a2.185,2.185,0,0,1,2.185-2.186h18.521a2.186,2.186,0,0,1,2.186,2.186Z",
    transform: "translate(-2044.644 -2160.503)",
    fill: "#eef6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27380",
    "data-name": "Path 27380",
    d: "M819.214,1103.486a41.645,41.645,0,1,1,41.644-41.646,41.692,41.692,0,0,1-41.644,41.646",
    transform: "translate(-725.174 -951.452)",
    fill: "#eef6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27381",
    "data-name": "Path 27381",
    d: "M1095.236,17.582H1063.75a7.1,7.1,0,0,1-7.094-7.094V7.1A7.1,7.1,0,0,1,1063.75,0h31.487a7.1,7.1,0,0,1,7.1,7.094v3.393a7.1,7.1,0,0,1-7.1,7.094",
    transform: "translate(-985.453 -0.002)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27382",
    "data-name": "Path 27382",
    d: "M201.323,2772.209H20.016a2.186,2.186,0,0,1,0-4.372H201.323a2.186,2.186,0,0,1,0,4.372",
    transform: "translate(-16.629 -2581.328)",
    fill: "#36383f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27383",
    "data-name": "Path 27383",
    d: "M231.009,2001.08H204.894a2.186,2.186,0,0,1-2.185-2.186v-23.114a2.185,2.185,0,0,1,2.185-2.185h26.115a2.186,2.186,0,0,1,2.186,2.185v23.114a2.186,2.186,0,0,1-2.186,2.186",
    transform: "translate(-189.05 -1840.606)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27384",
    "data-name": "Path 27384",
    d: "M2164.327,2001.08h-26.115a2.186,2.186,0,0,1-2.186-2.186v-23.114a2.185,2.185,0,0,1,2.186-2.185h26.115a2.185,2.185,0,0,1,2.186,2.185v23.114a2.186,2.186,0,0,1-2.186,2.186",
    transform: "translate(-1992.092 -1840.606)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27385",
    "data-name": "Path 27385",
    d: "M992.977,1264.714a29.088,29.088,0,1,1,29.089-29.089,29.122,29.122,0,0,1-29.089,29.089",
    transform: "translate(-898.938 -1125.236)",
    fill: "#ff455c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27386",
    "data-name": "Path 27386",
    d: "M1159.9,1414.061h-11.859a2.186,2.186,0,0,1-2.186-2.185v-7.157H1138.7a2.186,2.186,0,0,1-2.186-2.186v-11.857a2.186,2.186,0,0,1,2.186-2.186h7.157v-7.157a2.186,2.186,0,0,1,2.186-2.185H1159.9a2.187,2.187,0,0,1,2.186,2.185v7.157h7.156a2.186,2.186,0,0,1,2.186,2.186v11.857a2.186,2.186,0,0,1-2.186,2.186h-7.156v7.157a2.186,2.186,0,0,1-2.186,2.185",
    transform: "translate(-1059.926 -1286.214)",
    fill: "#eef6ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27387",
    "data-name": "Path 27387",
    d: "M602.579,1797.46v23.114a2.186,2.186,0,0,1-2.186,2.186h-1.611V1839.1h82.292c-34.555-14.51-61.7-35.615-82.292-56.707v12.884h1.611a2.186,2.186,0,0,1,2.186,2.185",
    transform: "translate(-558.433 -1662.286)",
    fill: "#e62e2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27388",
    "data-name": "Path 27388",
    d: "M2110.834,2731.141v2.473h8.272q-4.2-1.172-8.272-2.473",
    transform: "translate(-1968.597 -2547.105)",
    fill: "#454545",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27389",
    "data-name": "Path 27389",
    d: "M281.941,2381.466H259.048V2397.8h22.893v-16.339Z",
    transform: "translate(-241.592 -2220.992)",
    fill: "#d9e0e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27390",
    "data-name": "Path 27390",
    d: "M202.709,1975.781v23.114a2.186,2.186,0,0,0,2.185,2.186h26.115a2.186,2.186,0,0,0,2.186-2.186v-23.114a2.186,2.186,0,0,0-2.186-2.185H204.894a2.185,2.185,0,0,0-2.185,2.185",
    transform: "translate(-189.05 -1840.606)",
    fill: "#454545",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27391",
    "data-name": "Path 27391",
    d: "M0,1009v106.636a2.186,2.186,0,0,0,2.186,2.186h15.27V1101.48H15.845a2.185,2.185,0,0,1-2.185-2.186v-23.114A2.185,2.185,0,0,1,15.845,1074h1.611v-39.409A290.081,290.081,0,0,1,0,1009",
    transform: "translate(0 -941.006)",
    fill: "#e62e2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27392",
    "data-name": "Path 27392",
    d: "M259.048,1388.76v39.409h22.893v-12.884a288.113,288.113,0,0,1-22.893-26.525",
    transform: "translate(-241.592 -1295.179)",
    fill: "#d9e0e8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedkitIcon);
export default __webpack_public_path__ + "static/media/MedkitIcon.5a3eaa5f89b926466757b10abd8c9194.svg";
export { ForwardRef as ReactComponent };